import axios from 'axios'
import { backendLink } from '@/main'
import type { FormStatistics, NotInvoiced, Documentation } from '@/interfaces'

export class GeneralWrapper {

    async getFormStatistics(): Promise<FormStatistics[]> {
        return this.callToApi<FormStatistics[]>("form-statistics.php");
    }

    async getNotInvoiced(): Promise<NotInvoiced[]> {
        return this.callToApi<NotInvoiced[]>("not-invoiced.php");
    }

    async getDocs(): Promise<Documentation[]> {
        return this.callToApi<[]>("docs.php");
    }

    private async callToApi<T>(route: string): Promise<T> {
        const response = await axios.get(`${backendLink}/${route}`);
        return response?.data;
    }
}